export default __webpack_public_path__ + "static/default-share-image-3f8ba5eeefd3ebc9f97ea02ff311f37e.jpg";